import React from "react";
import {
    RenderNumber,
    RenderCurrency,
} from "Utils/renderField/renderReadField";
import NumberFormat from "react-number-format";
import { icons } from "icons";
import { fractions } from "utility/variables"; 
import { validarConfDecimales } from "../../Utils/validaConfiguracionDecimal";
import Tooltip from "rc-tooltip";

export function formatoIngreso(props) {
    return (cell, producto) => {
        const fractionMap = fractions.reduce((map, fraction) => {
            map[fraction.fraction] = fraction.value;
            return map;
        }, {}); 

        const handleFractionChange = (fraction) => {
            const fractionValue = fractionMap[fraction] || 0;
            const integerPart = Math.floor(producto.ingreso || 0);
            const newValue = integerPart + fractionValue;
            producto.currentFraction = fraction;
            props.asignarIngreso(producto, newValue);
        };

        const handleIntegerChange = (integerValue) => {
            const fractionValue = fractionMap[producto.currentFraction] || 0;
            const newValue = integerValue + fractionValue;
            props.asignarIngreso(producto, newValue);
        };

        return (
            <div className="d-flex flex-row">
                <button
                    className="btn btn-cantidad-detalle btn-menos"
                    onClick={() => {
                        const ingreso = producto.ingreso ? producto.ingreso : 0;
                        props.asignarIngreso(producto, ingreso - 1);
                    }}
                    type="button"
                >
                    <img src={icons.menos} alt="-" />
                </button>
                {props.conf_tipo_negocio === "Telas" && producto.producto.a_granel ? (
                    <div className="d-flex flex-row align-items-center">
                        <NumberFormat
                            className="form-control bodega-ingreso text-right"
                            placeholder="0"
                            decimalScale={0}
                            fixedDecimalScale={true}
                            value={Math.floor(producto.ingreso || 0)} 
                            thousandSeparator={true}
                            prefix={""}
                            style={{ padding: "2px" }}
                            onValueChange={(values) => {
                                handleIntegerChange(values.floatValue);
                            }}
                        />
                        <select
                            className="form-control ml-2"
                            style={{ width: "80px" }}
                            value={producto.currentFraction || ""}
                            onChange={(e) => handleFractionChange(e.target.value)}
                        >
                            <option value="">Unidad</option>
                            {fractions.map((fraction) => (
                                <option key={fraction.fraction} value={fraction.fraction}>
                                    {fraction.fraction}
                                </option>
                            ))}
                        </select>
                    </div>
                ) : (
                    <NumberFormat
                        className="form-control bodega-ingreso text-right"
                        placeholder="0"
                        decimalScale={producto.producto.a_granel ? 3 : 0}
                        fixedDecimalScale={
                            producto.producto.a_granel ? true : false
                        }
                        value={producto.ingreso}
                        thousandSeparator={true}
                        prefix={""}
                        style={{ padding: "2px" }}
                        onValueChange={(values) => {
                            let val = "";
                            if (
                                values.value !== "" &&
                                values.value !== undefined &&
                                values.value !== null
                            ) {
                                val = producto.producto.a_granel
                                ? parseFloat(values.value)
                                : parseInt(values.value);
                            }
                            props.asignarIngreso(producto, val);
                        }}
                    />
                )}
                <button
                    className="btn btn-cantidad-detalle btn-mas"
                    onClick={() => {
                        const ingreso = producto.ingreso ? producto.ingreso : 0;
                        props.asignarIngreso(producto, ingreso + 1);
                    }}
                    type="button"
                >
                    <img src={icons.mas} alt="+" />
                </button>
            </div>
        );
    };
}

export function formatoCosto(props) {
    return (cell, producto) => {
        // Guardar costo original solo una vez
        if (producto.costoOriginal === undefined || producto.costoOriginal === null) {
            producto.costoOriginal = producto.costo || 0;
        }

        const handleCostoChange = (nuevoCosto) => {
            if (nuevoCosto === undefined || nuevoCosto === null || isNaN(nuevoCosto)) {
                producto.costo = "";
                producto.mostrarAlertaCosto = false;
                props.asignarCosto(producto, ""); 
                return;
            }

            const valor = parseFloat(nuevoCosto);
            producto.costo = valor;

            if (producto.costoOriginal > 0) {
                const limiteInferior = producto.costoOriginal * 0.95; // -5%
                const limiteSuperior = producto.costoOriginal * 1.05; // +5%
                
                console.log("costo original: ", producto.costoOriginal);    
                console.log("limiteInferior: ", limiteInferior);
                console.log("limiteSuperior: ", limiteSuperior);

                producto.mostrarAlertaCosto =
                    valor < limiteInferior || valor > limiteSuperior;
            } else {
                producto.mostrarAlertaCosto = false;
            }

            // Esto fuerza re-render desde arriba
            props.asignarCosto({ ...producto }, valor);
        };

        return (
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <NumberFormat
                    className="form-control text-right"
                    placeholder="0"
                    decimalScale={props.conf_empresa ? validarConfDecimales(props.conf_empresa) : 2}
                    fixedDecimalScale={true}
                    value={producto.costo}
                    thousandSeparator={true}
                    prefix={props.pais === "GT" ? "Q " : "$ "}
                    onValueChange={(values) => handleCostoChange(values.floatValue)}
                    allowEmptyFormatting={true}
                />
                {producto.mostrarAlertaCosto && (
                    <Tooltip
                        placement="top"
                        overlay={
                            <div>
                                <strong>El nuevo precio difiere en más <br /> del 5 % respecto al último  <br />registrado en esta sucursal.</strong>
                                <br />
                                Por favor, revisa antes de  <br /> confirmar el ingreso. 
                            </div>
                        }
                    >
                        <em
                            className="text-danger fa fa-exclamation-triangle opacityPulse-css"
                            style={{ marginLeft: "5px" }}
                        />
                    </Tooltip>
                )}
            </div>
        );
    };
}



export function formatoPrecio(props) {
    return (cell, producto) => {
        return (
            <div>
                <NumberFormat
                    className="form-control text-right"
                    placeholder="0"
                    decimalScale={props.conf_empresa? validarConfDecimales(props.conf_empresa): 2}
                    // decimalScale={2}
                    fixedDecimalScale={true}
                    value={producto.precio}
                    thousandSeparator={true}
                    prefix={props.pais == "GT" ? "Q " : "$ "}
                    onValueChange={(values) => {
                        props.asignarPrecio(producto, values.value);
                    }}
                    isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue === undefined || floatValue <= 100000;
                    }}
                />
            </div>
        );
    };
}

export function formatoPrecioSucursal(props) {
    return (cell, producto) => {
        return (
            <div>
                <NumberFormat

                    className="form-control text-right"
                    placeholder="0"
                    decimalScale={props.conf_empresa? validarConfDecimales(props.conf_empresa): 2}
                    fixedDecimalScale={true}
                    value={producto.precio_sucursal}
                    thousandSeparator={true}
                    prefix={props.pais == "GT" ? "Q " : "$ "}
                    onValueChange={(values) => {
                        props.asignarPrecioSucursal(producto, values.value);
                    }}
                    isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue === undefined || floatValue <= 100000;
                    }}
                />
            </div>
        );
    };
}

export function formatoSubtotal(cell, producto) {
    let subtotal = 0;
    if (producto.ingreso && producto.costo) {
        subtotal = parseFloat(producto.ingreso) * parseFloat(producto.costo);
    }
    return (
        <div>
            <div>
                <RenderCurrency value={subtotal} />
            </div>
        </div>
    );
}

export function formatoUnidadesMedida(props) {
    return (cell, producto) => {
        return (
            <div>
                {producto.producto.a_granel && (
                    <select
                        className="form-control"
                        value={producto.id_unidad_de_medida}
                        onChange={(event) => {
                            const value = event.target.value;
                            props.asignarUnidadDeMedida(producto, value);
                        }}
                    >
                        {producto.unidades_de_medida.map((unidad) => {
                            return (
                                <option key={unidad.id} value={unidad.id}>
                                    {unidad.nombre}
                                </option>
                            );
                        })}
                    </select>
                    // <Select
                    //     className="form-control"
                    //     options={producto.unidades_de_medida}
                    //     valueKey="id"
                    //     labelKey="nombre"
                    //     value={producto.id_unidad_medida}
                    //     onChange={(e) => { console.log("SELECCION: ", e);
                    //      }}
                    // />
                )}
            </div>
        );
    };
}
